import React from "react";

// Split text on URLs and render them as clickable links; plain text is returned
// as-is (use a `whitespace-pre-line` container to preserve line/paragraph breaks).
const URL_RE = /(https?:\/\/[^\s]+)/g;

export function linkify(text) {
  return String(text || "").split(URL_RE).map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      const m = part.match(/^(.*?)([.,;:!?)\]]*)$/);
      const url = (m && m[1]) || part;
      const tail = (m && m[2]) || "";
      return (
        <React.Fragment key={i}>
          <a href={url} target="_blank" rel="noopener noreferrer"
            className="text-[#00F0FF] underline break-all hover:text-[#33f5ff]" data-testid="data-item-desc-link">{url}</a>{tail}
        </React.Fragment>
      );
    }
    return part;
  });
}
